// extracted by mini-css-extract-plugin
export var numpadContainer = "_oa-1";
export var phoneButton = "_oa-0";